import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MinimalPharmacyPage from "./pages/MinimalPharmacyPage";
import PharmacyHomePage from "./pages/PharmacyHomePage";
import CategoryPage from "./pages/CategoryPage";
import Home from "./pages/Home";
import AdminPanel from "./pages/AdminPanel";
import { Toaster } from "./components/ui/sonner";
import { SiteDataProvider } from "./context/SiteDataContext";

function App() {
  return (
    <div className="App">
      <SiteDataProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<MinimalPharmacyPage />} />
            <Route path="/full" element={<PharmacyHomePage />} />
            <Route path="/category/:categoryId" element={<CategoryPage />} />
            <Route path="/oncology" element={<CategoryPage />} /> {/* Legacy redirect mapping */}
            <Route path="/mediseller-main" element={<Home />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </SiteDataProvider>
    </div>
  );
}

export default App;
